import axios from 'axios'

const clientAdminApi = axios.create({
    baseURL: '/api/'    
});

const AdminWholesaleAPI = axios.create({
    baseURL: '/adminapi/'
});

export default {
    clientAdminApi: clientAdminApi,
    AdminWholesaleAPI: AdminWholesaleAPI
}